import axios from "axios"
import { API_URLS } from "../constants/ApiUrls";

export const fetchDataSourcesFromApi = async () => {
    const response = await axios.get(API_URLS.DATA_SOURCES)
    if (response.status === 200) {
        return response.data;
    }
    return []
}